export type InstallationFuelShareEstimate = {
  installation: {
    id: number;
    name: string;
  }
}

export type Meter = {
  id: number;
  name: string;
  location: number;
  installation_fuel_share_estimates: InstallationFuelShareEstimate[];
  reported_fuel_usage_periods: any[];
}

export type MeterReading = {
  value: Quantity;
  timestamp: string;
}

export type Quantity = {
  magnitude: number;
  units: meterQuantityUnitId
}

export const meterQuantityUnits = {
  "kilostandard_cubic_foot": "kscf",
  "US_therm": "therms",
  "USD": "dollars"
}

export type meterQuantityUnitId = keyof typeof meterQuantityUnits;
